"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const mastercard = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-mastercard` : '') + (description ? ` desc-mastercard` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-mastercard"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-mastercard"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37 0.119995C38.1046 0.119995 39 1.01543 39 2.11999V21.87C39 22.9746 38.1046 23.87 37 23.87H3C1.89543 23.87 1 22.9746 1 21.87V2.11999C1 1.01543 1.89543 0.119995 3 0.119995H37Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37 0.119995C38.1046 0.119995 39 1.01543 39 2.11999V21.87C39 22.9746 38.1046 23.87 37 23.87H3C1.89543 23.87 1 22.9746 1 21.87V2.11999C1 1.01543 1.89543 0.119995 3 0.119995H37ZM37 0.619995H3C2.2203 0.619995 1.57955 1.21488 1.50687 1.97554L1.5 2.11999V21.87C1.5 22.6497 2.09489 23.2904 2.85554 23.3631L3 23.37H37C37.7797 23.37 38.4204 22.7751 38.4931 22.0145L38.5 21.87V2.11999C38.5 1.3403 37.9051 0.699546 37.1445 0.626862L37 0.619995Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.31 12C28.3081 13.974 27.0855 15.741 25.239 16.4387C23.3924 17.1364 21.3068 16.6194 20 15.14C21.5842 13.3502 21.5842 10.6598 20 8.87001C21.3056 7.39193 23.3887 6.87436 25.2343 7.5695C27.0799 8.26464 28.3039 10.0279 28.31 12Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.19 12C21.1889 13.1566 20.7658 14.2731 20 15.14C18.4158 13.3502 18.4158 10.6598 20 8.87C20.7635 9.73428 21.1865 10.8468 21.19 12Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.81 12C18.8112 13.1566 19.2343 14.2731 20 15.14C18.6951 16.6254 16.6065 17.1471 14.7564 16.4498C12.9063 15.7526 11.6815 13.9822 11.6815 12.005C11.6815 10.0278 12.9063 8.25744 14.7564 7.56018C16.6065 6.86292 18.6951 7.38463 20 8.87C19.2366 9.73429 18.8136 10.8468 18.81 12Z",
    fill: "#EB001B"
  }));
};
var _default = exports.default = mastercard;